import LazyLoad from "vanilla-lazyload"

const initialClassNames = [
  "ca:opacity-0",
  "ca:transition",
  "ca:duration-150",
  "ca:transition-opacity",
]

const lazyLoadDefaults = {
  class_loaded: "ca:opacity-100",
}

export default function lazyLoad(el: HTMLElement, lazyLoadOptions: any) {
  el.classList.add(...initialClassNames)

  const instance = new LazyLoad(
    {
      ...lazyLoadDefaults,
      ...lazyLoadOptions,
    },
    // @ts-ignore
    [el]
  )
  return {
    update: () => {},
    destroy: () => {
      instance.destroy()
    },
  }
}
